import { components } from "@opstel/gen/api/v2";
import { z } from "zod";

export interface ScenarioBorderSelection {
  scenarioTrainId: string;
  scenarioBorderTrack: string;
}

export const scenarioBorderSelectionSchema = z.object({
  scenarioTrainId: z.string(),
  scenarioBorderTrack: z.string(),
}) satisfies z.ZodType<ScenarioBorderSelection, components["schemas"]["ScenarioBorderSelection"]>;
